import React, { useState } from "react";

function ProfilePicture(props) {
  const [values, setValues] = useState({});

  return (
    <div className="ProfilePicture">
      <div></div>
    </div>
  );
}

export default ProfilePicture;
